export default () => ({
  init() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("sortBy")) this.sortBy = params.get("sortBy");

    if (params.get("sortOrder")) this.sortOrder = params.get("sortOrder");

    if (params.get("categories")) {
      this.filters.categories = params.get("categories").split(",");
    }
  },
  open: false,
  filterDropdownOpen: false,
  sortBy: "area",
  sortOrder: "desc",
  filters: {
    categories: [],
  },
  sortByOptions: [
    { value: "price", label: "Price" },
    { value: "area", label: "Area (m²)" },
    { value: "roofspanLength", label: "Length (m)" },
    { value: "numberOfBedrooms", label: "Number of Bedrooms" },
  ],
  sortOrderOptions: [
    { value: "asc", label: "Ascending" },
    { value: "desc", label: "Descending" },
  ],
  updateUrl() {
    const params = new URLSearchParams();
    const {
      sortBy,
      sortOrder,
      filters: { categories },
    } = this;

    if (sortBy !== "default") {
      params.set("sortBy", sortBy);
    }

    params.set("sortOrder", sortOrder);

    if (categories.length > 0) {
      params.set("categories", categories.join(","));
    }

    const queryString = `?${params.toString()}`;
    const newLocation = `${location.origin}${location.pathname}${queryString}`;

    history.replaceState(null, "", queryString);

    // Show a loader
    const oldListingContainer = document.querySelector(
      "[data-filtered-content]"
    );
    if (oldListingContainer) {
      const loader = document.createElement("div");
      loader.setAttribute("class", "loader");
      oldListingContainer.prepend(loader);

      fetch(newLocation)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const htmlResponse = parser.parseFromString(data, "text/html");
          const newListingContainer = htmlResponse.querySelector(
            "[data-filtered-content]"
          );

          if (newListingContainer && oldListingContainer) {
            oldListingContainer.innerHTML = newListingContainer.innerHTML;
          }
        })
        .catch((error) => {
          console.error("Error fetching new content:", error);
        })
        .finally(() => {
          if (loader.parentNode) {
            loader.parentNode.removeChild(loader);
          }
        });
    } else {
      console.warn("Old listing container not found.");
    }
  },
  clearFilters() {
    this.filters.categories = [];
    this.updateUrl();
  },
  removeFilter(id) {
    this.filters.categories = this.filters.categories.filter((a) => a !== id);
    this.updateUrl();
  },
});
